import { getSettingDevice, isStrEmpty } from '@/utils/utils'
import axios from 'axios'
import axiosLib from 'axios'

const axiosAuth2 = axiosLib.create()

axiosAuth2.interceptors.request.use((request) => {
    const token = process.env.VUE_APP_TOKEN
    let setting: any = getSettingDevice()

    if (token) {
        request.headers.Authorization = token
        request.headers.ContentType = 'application/json'
    }

    if (!isStrEmpty(setting)) {
        setting = JSON.parse(setting)
        request.headers['Device-Network-Mac-Address'] = setting.mac
        request.headers['Device-Serial-Number'] = setting.serial
        request.headers['Device-Unique-Id'] = setting.uniqueId
        request.headers['App-Version'] = setting.appVersion
    }

    return request
})

axiosAuth2.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data)
        }
        return Promise.reject(error.message)
    }
)

export default axiosAuth2
